
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upload-music",
      function () {
        return require("private-next-pages/upload-music/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upload-music"])
      });
    }
  